<style scoped lang="less">
@media screen and (min-width: 460px) {
  .wh_item_date:hover {
    background: #fff;
    cursor: pointer;
    border-radius: 50%;
  }
}
* {
  margin: 0;
  padding: 0;
}

.wh_container {
  margin: auto;
}

li {
  list-style-type: none;
}
.wh_top_changge {
  display: flex;
  justify-content: space-between;
  padding: 0 44px;
}

.wh_top_changge li {
  cursor: pointer;
  display: flex;
  color: #333333;
  font-size: 24px;
  font-weight: 600;
  justify-content: center;
  align-items: center;
  height: 94px;
}

.wh_top_changge .wh_content_li {
  cursor: auto;
  flex: 2.5;
}
.wh_content_all {
  font-family: -apple-system, BlinkMacSystemFont, "PingFang SC",
    "Helvetica Neue", STHeiti, "Microsoft Yahei", Tahoma, Simsun, sans-serif;
  width: 100%;
  overflow: hidden;
  padding-bottom: 8px;
}

.wh_content {
  display: flex;
  flex-wrap: wrap;
  padding: 0 3% 0 3%;
  width: 100%;
}

.wh_content:first-child .wh_content_item_tag,
.wh_content:first-child .wh_content_item {
  color: red; //todo
  font-size: 32px;
}

.wh_content_item,
.wh_content_item_tag {
  font-size: 18px;
  width: 13.4%;
  text-align: center;
  color: #262626;
  position: relative;
}
.wh_content_item {
  height: 60px;
}

.wh_top_tag {
  width: 64px;
  height: 64px;
  line-height: 64px;
  margin: auto;
  display: flex;
  justify-content: center;
  align-items: center;
}

.wh_item_date {
  width: 40px;
  height: 40px;
  line-height: 40px;
  margin: auto;
  display: flex;
  justify-content: center;
  align-items: center;
  /deep/ .is-fixed {
    top: 5px;
    right: 5px;
  }
  /deep/ .el-badge__content {
    background-color: #ffae00;
  }
}

.wh_jiantou1 {
  width: 12px;
  height: 12px;
  border-top: 4px solid #8c8c8c;
  border-left: 4px solid #8c8c8c;
  transform: rotate(-45deg);
}

.wh_jiantou1:active,
.wh_jiantou2:active {
  border-color: #ddd;
}

.wh_jiantou2 {
  width: 12px;
  height: 12px;
  border-top: 4px solid #8c8c8c;
  border-right: 4px solid #8c8c8c;
  transform: rotate(45deg);
}
.wh_content_item > .wh_isMark {
  margin: auto;
  border-radius: 200px;
  background: blue;
  z-index: 2;
}
.wh_content_item .wh_other_dayhide {
  color: #bfbfbf;
}
.wh_content_item .wh_want_dayhide {
  color: #bfbfbf;
}
.wh_content_item .wh_isToday {
  box-sizing: border-box;
  border-radius: 200px;
  color: #fff;
  background: linear-gradient(180deg, #0472fc 0%, #368fff 100%);
}
.wh_content_item .wh_chose_day {
  border: 2px solid #368fff;
  border-radius: 200px;
}

/* 自定义样式 */
@red: #ff5353;
@green: #52c41a;
@yellow: #ff9c00;
@blue: #368fff;
.wh-calendar_bottom {
  width: 90px;
  font-size: 25px;
  font-weight: 400;
  line-height: 36px;
  border-radius: 7px;
}
&.yellow .wh-calendar_bottom {
  color: @yellow;
  background: fade(@yellow, 5);
  border: 2px solid @yellow;
}
&.green .wh-calendar_bottom {
  color: @green;
  background: fade(@green, 5);
  border: 2px solid @green;
}
&.red .wh-calendar_bottom {
  color: @red;
  background: fade(@red, 5);
  border: 2px solid @red;
}
&.blue .wh-calendar_bottom {
  color: @blue;
  background: fade(@blue, 5);
  border: 2px solid @blue;
}
</style>
<template>
  <section class="wh_container">
    <div class="wh_content_all">
      <div class="wh_top_changge">
        <li @click="PreMonth(myDate, false)">
          <div class="wh_jiantou1"></div>
        </li>
        <li class="wh_content_li">{{ dateTop }}</li>
        <li @click="NextMonth(myDate, false)">
          <div class="wh_jiantou2"></div>
        </li>
      </div>
      <div class="wh_content">
        <div class="wh_content_item" v-for="tag in textTop" :key="tag">
          <div class="wh_top_tag">{{ tag }}</div>
        </div>
      </div>
      <div class="wh_content">
        <div class="wh_content_item" :class="item.className" v-for="(item, index) in list"
          @click="clickDay(item, index)" :key="index">
          <div class="wh_item_date" v-bind:class="[
              { wh_isMark: item.isMark },
              { wh_other_dayhide: item.otherMonth !== 'nowMonth' },
              { wh_want_dayhide: item.dayHide },
              { wh_isToday: item.isToday },
              { wh_chose_day: item.chooseDay },
              setClass(item),
            ]">
            <el-badge v-if="item.count && item.count > 1" :value="item.count > 99 ? '99+' : item.count" class="item"
              type="warning">
              {{ item.id }}
            </el-badge>
            <el-badge v-else-if="item.count && item.count === 1" is-dot class="dot">{{ item.id }}</el-badge>
            <span v-else>{{ item.id }} {{item.count}}</span>
          </div>
          <div class="wh-calendar_bottom">{{ item.bottomInfo }}</div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
/* eslint-disable no-unused-vars */
import timeUtil from "./calendar";
export default {
  data() {
    return {
      myDate: [],
      list: [],
      historyChose: [],
      dateTop: "",
      currentMonthData: [],
    };
  },
  props: {
    formatter: Function,
    markDate: {
      type: Array,
      default: () => [],
    },
    markDateMore: {
      type: Array,
      default: () => [],
    },
    textTop: {
      type: Array,
      default: () => ["一", "二", "三", "四", "五", "六", "日"],
    },
    sundayStart: {
      type: Boolean,
      default: () => false,
    },
    agoDayHide: {
      type: String,
      default: "0",
    },
    futureDayHide: {
      type: String,
      default: "2554387200",
    },
  },
  created() {
    this.intStart();
    this.myDate = new Date();
  },
  methods: {
    intStart() {
      timeUtil.sundayStart = this.sundayStart;
    },
    setClass(data) {
      const obj = {};
      obj[data.markClassName] = data.markClassName;
      return obj;
    },
    clickDay: function (item, index) {
      if (item.otherMonth === "nowMonth" && !item.dayHide) {
        this.getList(this.myDate, item.date, true, true);
      }
      if (item.otherMonth !== "nowMonth") {
        item.otherMonth === "preMonth"
          ? this.PreMonth(item.date)
          : this.NextMonth(item.date);
      }
    },
    ChoseMonth: function (date, isChosedDay = true) {
      date = timeUtil.dateFormat(date);
      this.myDate = new Date(date);
      this.$emit("changeMonth", timeUtil.dateFormat(this.myDate));
      if (isChosedDay) {
        this.getList(this.myDate, date, isChosedDay);
      } else {
        this.getList(this.myDate);
      }
    },
    PreMonth: function (date, isChosedDay = true) {
      date = timeUtil.dateFormat(date);
      this.myDate = timeUtil.getOtherMonth(this.myDate, "preMonth");
      this.$emit("changeMonth", timeUtil.dateFormat(this.myDate));
      if (isChosedDay) {
        this.getList(this.myDate, date, isChosedDay);
      } else {
        this.getList(this.myDate);
      }
    },
    NextMonth: function (date, isChosedDay = true) {
      date = timeUtil.dateFormat(date);
      this.myDate = timeUtil.getOtherMonth(this.myDate, "nextMonth");
      this.$emit("changeMonth", timeUtil.dateFormat(this.myDate));
      if (isChosedDay) {
        this.getList(this.myDate, date, isChosedDay);
      } else {
        this.getList(this.myDate);
      }
    },
    forMatArgs: function () {
      let markDate = this.markDate;
      let markDateMore = this.markDateMore;
      markDate = markDate.map((k) => {
        return timeUtil.dateFormat(k);
      });
      markDateMore = markDateMore.map((k) => {
        k.date = timeUtil.dateFormat(k.date);
        return k;
      });
      return [markDate, markDateMore];
    },
    getList: function (
      date,
      chooseDay,
      isChosedDay = true,
      isClickDay = false
    ) {
      const [markDate, markDateMore] = this.forMatArgs();
      this.dateTop = `${date.getFullYear()}-${date.getMonth() + 1}`;
      let arr = timeUtil.getMonthList(this.myDate);
      for (let i = 0; i < arr.length; i++) {
        let markClassName = "";
        const k = arr[i];
        k.chooseDay = false;
        const nowTime = k.date;
        const t = new Date(nowTime).getTime() / 1000;
        // 看每一天的class
        for (const c of markDateMore) {
          if (c.date === nowTime) {
            markClassName = c.className || "";
          }
        }
        // 标记选中某些天 设置class
        k.markClassName = markClassName;
        k.isMark = markDate.indexOf(nowTime) > -1;
        // 无法选中某天
        k.dayHide = t < this.agoDayHide || t > this.futureDayHide;
        if (k.isToday) {
          this.$emit("isToday", nowTime);
        }
        const flag = !k.dayHide && k.otherMonth === "nowMonth";
        if (chooseDay && chooseDay === nowTime && flag) {
          this.$emit("choseDay", nowTime);
          this.historyChose.push(nowTime);
          k.chooseDay = true;
        } else if (
          this.historyChose[this.historyChose.length - 1] === nowTime &&
          !chooseDay &&
          flag
        ) {
          k.chooseDay = true;
        }
      }
      if (this.formatter) {
        arr = arr.map((item) => this.formatter(item));
      }
      this.list = arr;
      // this.getCurrentMonthDate(this.dateTop);
      if (!isClickDay) {
        this.getCurrentMonthDate(this.dateTop);
      } else {
        this.compare(this.currentMonthData);
      }
    },
    // 获取月的数据 并比较
    async getCurrentMonthDate(month) {
      try {
        let req = {
          month: this.dateFormat(month),
        };
        let { code, data } = await this.$api.live.timetable(req);

        if (code === "1") {
          this.currentMonthData = data;
          this.compare(data);
        }
      } catch (error) {}
    },
    dateFormat(date) {
      let dateArr = date.split('-');
      let [y, m] = [dateArr[0], dateArr[1]];
      m = Number(m) > 9 ? m : '0' + m;
      return `${y}-${m}`
    },

    compare(data) {
      try {
        if (data.length) {
          data.map((item) => {
            let day = item.day.replace(/-/g, "/");
            this.list.map((i, index) => {
              if (i.time === day) {
                this.$set(this.list[index], "count", item.count);
              }
            });
          });
        }
      } catch (error) {
        console.log(error);
      }
    },
  },
  mounted() {
    this.getList(this.myDate, timeUtil.dateFormat(this.myDate));
  },
  watch: {
    markDate: {
      handler(val, oldVal) {
        this.getList(this.myDate);
      },
      deep: true,
    },
    markDateMore: {
      handler(val, oldVal) {
        this.getList(this.myDate);
      },
      deep: true,
    },
    agoDayHide: {
      handler(val, oldVal) {
        this.getList(this.myDate);
      },
      deep: true,
    },
    futureDayHide: {
      handler(val, oldVal) {
        this.getList(this.myDate);
      },
      deep: true,
    },
    sundayStart: {
      handler(val, oldVal) {
        this.intStart();
        this.getList(this.myDate);
      },
      deep: true,
    },
  },
};
</script>
